module.exports = __webpack_public_path__ + "img/92ne.3ba19cc9.svg";